import api from './client';

export async function createOrder(payload, config = {}) {
  const { data } = await api.post('/api/orders', payload, config);
  return data;
}

export async function trackOrder(orderId, phone) {
  const { data } = await api.get(`/api/orders/${orderId}/track`, {
    params: { phone },
  });
  return data;
}

export async function fetchOrderHistory(phone) {
  const { data } = await api.get('/api/orders/history', {
    params: { phone },
  });
  return data || [];
}
